var _rect, _rect2, _g, _path, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 400,
    viewBox: "0 0 1440 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 1440,
    height: 400,
    fill: "#001C80"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4551_132796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 1440,
    height: 400
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 1440,
    height: 400,
    fill: "#2B59FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4551_132796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1477.3,
    cy: -82.9723,
    rx: 308.889,
    ry: 344.272,
    fill: "#FFC83E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1588.41,
    cy: 65.6349,
    rx: 280,
    ry: 312.074,
    fill: "#00BB98"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M819.333 8.1173e-05C819.267 12.3507 824.271 24.2207 833.245 32.9989C842.219 41.7771 854.427 46.7444 867.183 46.808C879.939 46.8716 892.2 42.0263 901.266 33.3381C910.333 24.6499 915.463 12.8304 915.529 0.479784L819.333 8.1173e-05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.542377 176.933C10.998 176.864 20.9969 172.801 28.3393 165.639C35.6817 158.477 39.7662 148.802 39.6943 138.742C39.6224 128.682 35.3999 119.062 27.9558 111.998C20.5116 104.934 10.4557 101.004 0 101.073L0.542377 176.933Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 490.958,
    cy: 306.405,
    rx: 12.1856,
    ry: 11.7241,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.9ea6d0f9b57566f891063c83d007c345.svg";
export { ForwardRef as ReactComponent };